<div class="category-chips-container">
  <div class="chips-group">
    @for (category of visibleCategories; track category.id) {
      <button
        [class.chip]="true"
        [class.selected]="isSelected(category)"
        [class.disabled]="isMaxSelectionsReached() && !isSelected(category)"
        [disabled]="isMaxSelectionsReached() && !isSelected(category)"
        [style.background-color]="isSelected(category) && category.color ? category.color : null"
        [style.border-color]="isSelected(category) && category.color ? category.color : null"
        (click)="toggleCategory(category)"
        type="button"
        [attr.aria-pressed]="isSelected(category)"
        [title]="category.label | translate"
      >
        <span class="chip-label">{{ category.label | translate }}</span>
        @if (isSelected(category)) {
          <span class="chip-close">
            <ion-icon name="close"></ion-icon>
          </span>
        }
      </button>
    }
  </div>

  @if (selectedCategoryIds.length === 0) {
    <div class="empty-state">
      <p class="empty-message">{{ 'DATA_VISUALIZATION.NO_CATEGORIES_SELECTED' | translate }}</p>
    </div>
  }
</div>
